import { useSelector } from 'react-redux';

import { Box, Typography } from '@material-ui/core';

import Button from '../../../Button/Button.component';

import { useDeleteCard } from 'hooks/payments.hook';

const DeleteCardForm = () => {
  const { id } = useSelector(state => state.payments.target);

  const { mutate: deleteCard, isLoading } = useDeleteCard();

  const onClickHandler = event => {
    event.preventDefault();
    deleteCard(id);
  };

  return (
    <>
      <Typography>¿Estás seguro de eliminar esta forma de pago?</Typography>
      <Box pt={2} textAlign="center">
        <Button
          variant="contained"
          onClick={onClickHandler}
          loading={isLoading}
          color="primary"
        >
          Confirmar
        </Button>
      </Box>
    </>
  );
};

export default DeleteCardForm;
